import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/web'
import { catchFace } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/catchFace'
import { backAroundWeb } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/backAroundWeb'
import { stitch } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/stitch'
import { backOfIndexToLittle } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/backOfIndexToLittle'
import { boomerang } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/boomerang'
import { littleHook } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/littleHook'
import { liningLeather } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/liningLeather'
import { thumbHook } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/thumbHook'
import { laces } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/lace'
import { ragdelionEngravedOfBackFace, ragdelionLabel } from 'src/features/brands/ragdelion/canvas/labels/ragdelion'
import { loopOfRingFinger } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/loopOfRingFinger'
import { fingerGuardDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/wristBeltDrawer'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery,
  ragLionEmbroidery,
  firstMittChildFingerEmbroidery
} from 'src/features/brands/ragdelion/canvas/common/back/embroidery'
import { canvasResetter } from 'src/features/brands/ragdelion/canvas/common/canvasResetter'
import { bottomRightOfBeltEmbroideryDrawer } from 'src/features/brands/ragdelion/canvas/common/back/useCanvasEmbroideries'
import { indexFingerPad } from './fingerGuardDrawer/indexFingerPad'

export const ragdelionCanvasFirstMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return
  // リセット
  canvasResetter(ctx)
  // 裏革
  liningLeather(ctx, state.linings.color)
  // ragdelionライオン描画
  ragLionEmbroidery(ctx, state.ragLionLogo.value, state.ragLionLogoColor.color, -80, 50)

  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      110,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      110,
      -25
    )
  }

  if (state.loopOfRingFinger?.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state?.loopOfRingFingerColor?.color, state.stitch.color)
  }

  // 捕球面
  catchFace(ctx, state.catchFace.color)
  // ウェブ先端側
  webTop(ctx, state.web.color)
  // ウェブ捕球面側
  webBottom(ctx, state.web.color)
  // ブーメラン部分
  boomerang(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  backOfIndexToLittle(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'pinkyFingerSideBack')
  if (isEmbroideryOfChild) {
    firstMittChildFingerEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'pinkyFingerSideBack'),
      -75,
      575
    )
  }

  // 背面＿親指_
  backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color)
  // 手首ベルト
  wristBeltDrawer(ctx, state)
  // RAG de Lion のみ＿ベルト右下への刺繍
  bottomRightOfBeltEmbroideryDrawer(ctx, state.embroideries, 0, 30)

  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // 親指への刺繍
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -220,
      40,
      -20
    )
  }
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color)

  const fingerGuardType = state.fingerGuardType.value
  const indexCoverColor = state.indexCover.color
  const stitchColor = state.stitch.color
  const fingerGuardPosition = state.fingerGuardPosition.value
  const isPad = fingerGuardType === 'indexPad'
  const { x, y, numerator } = getFingerGuardPositionCoordinate(fingerGuardPosition)

  if (isPad) {
    indexFingerPad(ctx, indexCoverColor, stitchColor, x, y, numerator)
  }

  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  fingerGuardDrawer(ctx, fingerGuardType, indexCoverColor, stitchColor, fingerGuardPosition)

  // ラベル
  switch (state.labelPosition.value) {
    case 'onBelt':
      ragdelionLabel(ctx, state.ragLabel.value, -25, 30, 0, 1)
      break
    case 'byThumb':
      ragdelionLabel(ctx, state.ragLabel.value, -200, 310, -35, 0.85)
      ragdelionEngravedOfBackFace(ctx, state.catchFace.value, -15, 25)
      break
  }
  // 革紐
  laces(ctx, state.lace.color)
}

const getFingerGuardPositionCoordinate = (position: string) => {
  switch (position) {
    case 'onIndex':
      return { x: 10, y: 0, numerator: 0 }
    case 'onIndexLeft':
      return { x: -5, y: 5, numerator: 0 }
    case 'onFingerCrotch':
      return { x: -25, y: 15, numerator: -1 }
    case 'onMiddleRight':
      return { x: -62, y: 43, numerator: -5 }
    case 'onMiddle':
      return { x: -100, y: 55, numerator: -7 }
    default:
      return { x: 0, y: 0, numerator: 0 }
  }
}
